import React from 'react';
import ProfileTypeSelector from '../selectors/ProfileTypeSelector';
import { ProfileType } from '../../../../types/profileTypes';
import { Dispatch, SetStateAction } from 'react';

interface ProfileTypeGroupProps {
  profileType: '' | ProfileType;
  setProfileType: Dispatch<SetStateAction<'' | ProfileType>>;
  isFormValid: boolean;
  isLoading: boolean;
}

const ProfileTypeGroup: React.FC<ProfileTypeGroupProps> = ({
  profileType,
  setProfileType,
  isFormValid,
  isLoading,
}) => (
  <div className="mb-4 space-y-1">
    <div className="mb-2 text-sm text-gray-400">Select a profile type</div>
    <div className="mb-6 grid grid-cols-1 items-end gap-2 md:gap-4">
      <ProfileTypeSelector value={profileType} onChange={setProfileType} />
      <button
        type="submit"
        className="w-full rounded-md bg-gradient-to-r from-pink-500 to-purple-600 px-4 py-2 font-semibold text-white shadow-md hover:from-pink-600 hover:to-purple-700 focus:border-purple-600 focus:outline-none focus:ring-0 disabled:opacity-50"
        disabled={!isFormValid || isLoading}
      >
        {isLoading ? 'Signing up...' : 'Sign Up'}
      </button>
    </div>
  </div>
);

export default ProfileTypeGroup;
